<lib-wizard
    *ngIf="validarInformacionVista()"
    [readOnly]="readOnly"
    (backPage)="back()"
    [biosphereConfig]="biosphereConfig"
    [descargaZipByFolio]="descargaZipByFolio"
    [skipByVersion]="skipByVersion"
></lib-wizard>
